import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

const defaultMutationFn = async ({ queryKey }, data:any) => {
    // const { mutationFn = null, ...data } = params;
    const { data: response } = await authenticatedApi.put(`/${queryKey[0]}/${queryKey[1]}`, data);
    return response;//data.hasOwnProperty('data') ? data.data : data;
}

export function useDelete(queryParams) {
    const queryClient = useQueryClient();
    const { queryKey } = queryParams;

    return useMutation({
        mutationFn: async (data:any = {}) => {
            // used for multidelete
            let endpoint = `/${queryKey[0]}/${queryKey[1]}`;
            if(data?.ids) {
                endpoint = `${endpoint}?ids=${data?.ids}`;
            }

            const { data: response } = await authenticatedApi.delete(endpoint, data);
            return response;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            // console.log(queryKey);
            queryClient.invalidateQueries({ queryKey: [queryKey[0]] }); // leave this here
            queryClient.invalidateQueries({ queryKey });
        },
    });
}
